module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.25158",
      "conversations-internal-schema": "static-1.12198",
      "head-dlb": "static-1.4465",
      "hs-test-utils": "static-1.7478",
      "hubspot-url-utils": "static-1.3759",
      "HubStyleTokens": "static-2.11002",
      "I18n": "static-7.1488",
      "jasmine-runner": "static-1.5948",
      "quartz": "static-1.6332",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "webpack-env": "static-1.54",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.479",
      "visitor-ui-component-library": "static-1.5695",
      "enviro": "static-4.345",
      "hs-promise-rejection-tracking": "static-1.4918",
      "PortalIdParser": "static-2.319",
      "raven": "static-3.5386",
      "raven-hubspot": "static-1.5693",
      "bend-plugin-trellis-migration": "static-1.3022",
      "moment": "static-3.26",
      "cv-backend-services": "static-1.1397",
      "hub-http": "static-1.5499",
      "immutable": "static-2.19",
      "immutable-less": "static-1.4090",
      "quartz-config": "static-1.110",
      "quartz-core": "static-1.5551",
      "transmute": "static-2.77",
      "HeadJS": "static-2.649",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7071",
      "framer-motion": "static-1.58",
      "hs-test-utils-bend-plugin": "static-1.2589",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.140",
      "foundations-theming": "static-1.3896",
      "i18n-data": "static-1.212",
      "metrics-js": "static-1.9222",
      "moment-timezone": "static-5.73",
      "react-utils": "static-2.4925",
      "jasmine": "static-4.3807",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.44",
      "styled-components": "static-2.64",
      "UIComponents": "static-3.7949",
      "visitor-ui-component-library-icons": "static-1.5506",
      "bender-build-tools": "static-1.2674",
      "rpc-client-utils": "static-1.4188",
      "ts-schema": "static-1.3692",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.126",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-janus": "static-1.727",
      "hub-http-shared-msw-handlers": "static-1.8901",
      "hubspotter-http": "static-1.4219",
      "hubspotter-http-shared-msw-handlers": "static-1.8899",
      "icons": "static-2.599",
      "mobile-manifest-mixins": "static-1.422",
      "quick-fetch": "static-1.3515",
      "react-rhumb": "static-1.16196",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.335",
      "bend-plugin-foundations-components": "static-1.3340",
      "floating-ui": "static-1.46",
      "foundations-assets": "static-1.4356",
      "foundations-theming-specialty": "static-1.1612",
      "hs-story-utils": "static-1.8898",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.87",
      "tanstack-table": "static-1.23",
      "trellis-assets": "static-1.772",
      "ui-images": "static-2.1001",
      "bend-plugin-foundations-theming": "static-1.2379",
      "foundations-theming-base": "static-1.2881",
      "stylex": "static-1.22",
      "classnames": "static-2.10",
      "cssUtils": "static-1.640",
      "HubStyle": "static-2.11310",
      "sassPrefix": "static-1.146",
      "react-input-autosize": "static-2.17"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.25158",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12198",
      "head-dlb": "/head-dlb/static-1.4465",
      "hs-test-utils": "/hs-test-utils/static-1.7478",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3759",
      "HubStyleTokens": "/HubStyleTokens/static-2.11002",
      "I18n": "/I18n/static-7.1488",
      "jasmine-runner": "/jasmine-runner/static-1.5948",
      "quartz": "/quartz/static-1.6332",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.54",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.479",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5695",
      "enviro": "/enviro/static-4.345",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
      "PortalIdParser": "/PortalIdParser/static-2.319",
      "raven": "/raven/static-3.5386",
      "raven-hubspot": "/raven-hubspot/static-1.5693",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3022",
      "moment": "/moment/static-3.26",
      "cv-backend-services": "/cv-backend-services/static-1.1397",
      "hub-http": "/hub-http/static-1.5499",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.4090",
      "quartz-config": "/quartz-config/static-1.110",
      "quartz-core": "/quartz-core/static-1.5551",
      "transmute": "/transmute/static-2.77",
      "HeadJS": "/HeadJS/static-2.649",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7071",
      "framer-motion": "/framer-motion/static-1.58",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2589",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.140",
      "foundations-theming": "/foundations-theming/static-1.3896",
      "i18n-data": "/i18n-data/static-1.212",
      "metrics-js": "/metrics-js/static-1.9222",
      "moment-timezone": "/moment-timezone/static-5.73",
      "react-utils": "/react-utils/static-2.4925",
      "jasmine": "/jasmine/static-4.3807",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.44",
      "styled-components": "/styled-components/static-2.64",
      "UIComponents": "/UIComponents/static-3.7949",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5506",
      "bender-build-tools": "/bender-build-tools/static-1.2674",
      "rpc-client-utils": "/rpc-client-utils/static-1.4188",
      "ts-schema": "/ts-schema/static-1.3692",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.126",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-janus": "/hub-http-janus/static-1.727",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8901",
      "hubspotter-http": "/hubspotter-http/static-1.4219",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8899",
      "icons": "/icons/static-2.599",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.422",
      "quick-fetch": "/quick-fetch/static-1.3515",
      "react-rhumb": "/react-rhumb/static-1.16196",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.335",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3340",
      "floating-ui": "/floating-ui/static-1.46",
      "foundations-assets": "/foundations-assets/static-1.4356",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1612",
      "hs-story-utils": "/hs-story-utils/static-1.8898",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.87",
      "tanstack-table": "/tanstack-table/static-1.23",
      "trellis-assets": "/trellis-assets/static-1.772",
      "ui-images": "/ui-images/static-2.1001",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2379",
      "foundations-theming-base": "/foundations-theming-base/static-1.2881",
      "stylex": "/stylex/static-1.22",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.640",
      "HubStyle": "/HubStyle/static-2.11310",
      "sassPrefix": "/sassPrefix/static-1.146",
      "react-input-autosize": "/react-input-autosize/static-2.17"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};